import type { CustomerId } from "types/customer"
import type { ControlDesk } from "types/region"

const railCustomers: CustomerId[] = ["NR", "PB", "WAGON", "3RDRAIL", "RAIL"]
const roadsCustomers: CustomerId[] = [
  "SCC",
  "MED",
  "KCC",
  "DFI",
  "HOU",
  "WOK",
  "FMC",
  "PET",
  "ROADS",
  "RR",
  "RRD",
  "ABDS",
  "ANDY",
  "BCP",
  "USDEMO",
  "JER",
  "CAM",
  "CFX",
  "EDI",
  "LAN",
  "PIC",
  "ESUS",
  "ESS",
  "DON",
  "RCM",
  "WBRK",
  "LGW",
  "EGKK",
  "LHR",
  "ILN",
  "NOR",
  "TAM",
  "HERT",
  "GLOU",
  "MKE",
  "DVN",
  "BUCK",
  "NH",
  "STOC",
  "WSUS",
  "NBL",
  "EKFB",
  "AGB"
]

type Config = {
  apiBasePath: string
  railApiBasePath: string
  sherlockApiBasePath: string
  auth0Domain: string
  auth0ClientId: string
  auth0Audience: string
  customers: CustomerId[]
  controlDesks: ControlDesk[]
}

const config: Config = {
  apiBasePath: import.meta.env.VITE_USERS_API_URL || "https://api.routereports.com",
  railApiBasePath: `${import.meta.env.VITE_API_URL || "https://api.routereports.com"}/rail/dev`,
  // Customer config now lives in rr-api (Postgres-backed /customers routes,
  // replacing rr-lambda-sherlock) — same host + var as railApiBasePath, so
  // PR previews route automatically.
  sherlockApiBasePath: `${import.meta.env.VITE_API_URL || "https://api.routereports.com"}/rail/dev/customers`,
  auth0Domain: "rail-auth.routereports.com",
  auth0ClientId: "M0coqEtwxdG5qQu0K4PUqPQp00YXO8Eu",
  auth0Audience: "https://rail.routereports.com",
  customers: [...railCustomers, ...roadsCustomers],
  controlDesks: [
    "Sussex-Kent",
    "Wessex",
    "LNW North",
    "LNW South",
    "North and East",
    "Wales",
    "Western",
    "Scotland",
    "Anglia",
    "Channel Tunnel Rail Link",
    "East Coast",
    "East Midlands",
  ],
}

export default config
